<template>
  <Layout :title="`${title} | Clausify`">
    <div class="d-flex flex-grow-1 container">
      <div class="d-flex align-content-center justify-content-center flex-wrap flex-grow-1">
        <div class="py-5 my-5 container">
          <div class="row">
            <div class="col-lg-12 m-auto">
              <div>{{ message ? message : description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
  components: {
    Layout,
  },

  props: {
    status: Number,
    message: {
      type: String,
      required: false,
    },
  },

  computed: {
    title() {
      return {
        503: '503: Service Unavailable',
        500: '500: Server Error',
        404: '404: Page Not Found',
        403: 'Forbidden',
      }[this.status];
    },
    description() {
      return {
        503: 'Sorry, we are doing some maintenance. Please check back soon.',
        500: 'Whoops, something went wrong on our servers.',
        404: 'Sorry, the page you are looking for could not be found.',
        403: 'Sorry, you are forbidden from accessing this page.',
      }[this.status];
    },
  },
};
</script>
